import styled from "styled-components";

export const StyledText = styled.p`
  color: ${(props) => props.theme.colors.light};
`;
